export const TRUNCATED_PATH_PLACEHOLDER = "…"
